export const intentTypes = {
    loading: "LOADING_INTENT",
    delete: "DELETE_INTENT",
    loadedOne: "LOADED_INTENT",
    loadedMultiple: "LOADED_INTENTS",
    success: "SUCCESS_INTENT",
    restore: "RESTORE_INTENT",
    hardDelete: "HARDDELETE_INTENT",
};
